import { memo, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
// @mui
import {
  Box,
  Divider,
  Button,
  Drawer,
  CardContent,
  Card,
  CardHeader,
  Stack,
  Typography,
  TextField,
  Avatar,
  ButtonBase,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  SvgChevronLeftFill,
  SvgCloseFill,
  SvgDislikeFill,
  SvgLikeFill,
} from '../../SvgIcons';
import { onFeedbackHelp, queryFeedbackDetails, toggleFeedbackDetailsDrawer } from '../../../store/actions/feebackActions';
import { getAssetsUrl, getPictureUrl } from '../../../utils/@helper/file.helper';
import { COMMENT_FLAG, HLEP_FLAG } from '../../../store/types';
import FileIcon from '../../file/FileIcon';
import { getFileExtension } from '../../../utils/utils';

// components

// store

/* ======================================================================================= */


/* ======================================================================================= */
const FeedbackDetails = ({ ct }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { account, bulletins: { reply_details } } = useSelector(
    (state) => state
  );
  const { profile } = account || {};

  const { feedback: { isOpenFeedbackDetails, details } } = useSelector(state => state);

  const { state, commit } = useContext(ct);
  const { visible, record, reply_record, readFlag } = state || {};


  const handleCloseDetails = (visible) => (event) => {
    dispatch(toggleFeedbackDetailsDrawer(visible))
    // commit({
    //   type: 'OPEN_DETAILS_DRAWER',
    //   data: {
    //     ...state,
    //     visible: false,
    //     record: {},
    //     readFlag: null
    //   }
    // });
  };

  return (
    <Drawer
      variant={'temporary'}
      anchor={'right'}
      open={Boolean(isOpenFeedbackDetails)}
    >
      {/* 516 532 */}
      <Card sx={{ width: 532, overflow: 'visible' }}>
        <CardHeader
          disableTypography
          atrr-title={'消息詳情'}
          title={
            <Stack direction={'row'} alignItems={'center'}>
              <Stack direction={'row'} alignItems={'center'} spacing={0.5} paddingBlock={0.5} paddingInlineStart={1} paddingInlineEnd={1.5} sx={{ cursor: 'pointer' }} onClick={handleCloseDetails(false)}>
                <SvgChevronLeftFill color={theme.palette.color.primaryBlue3} size={16} sx={{ padding: '2px' }} />
                <Typography variant='body2' color={theme.palette.color.primaryBlue3}>
                  返回
                </Typography>
              </Stack>
              <Divider sx={{ width: '1px', height: 24, alignSelf: 'center', mx: 1 }} color={'text.secondary'} orientation="vertical" variant="middle" flexItem />
              <Typography variant={'h6'}>{t('詳情')}</Typography>
            </Stack>
          }
          action={<Box onClick={handleCloseDetails(false)} sx={{ cursor: 'pointer' }}><SvgCloseFill color={'text.primary'} /></Box>}
          sx={{
            py: 1,
            pl: 3,
            pr: 2,
            alignItems: 'center',
            borderBottom: '1px solid #CCC',
            '& .MuiCardHeader-action': {
              m: 0,
              lineHeight: 0,
              alignSelf: 'center',
            }
          }}
        />
        <CardContent>
          <Stack spacing={2}>
            <Typography variant={'h6'} mb={1} sx={{ ...theme.typography.leftLine, pb: 0.75, wordBreak: 'break-word' }}>
              { details?.messageTitle || '--' }
            </Typography>
            <Typography variant={'body2'} color={'text.secondary'} display={'flex'} alignItems={'center'}>
              {details?.createTime}
            </Typography>
            <Typography variant={'body1'} display={'flex'} alignItems={'center'} sx={{ wordBreak: 'break-word' }}>
              {details?.messageContent}
            </Typography>
            {
              _.map(details?.filePath?.split(','), (url, index) => (
                <Box key={index} display={'grid'} alignItems={'center'} gridTemplateColumns={'24px 1fr'} gap={0.5} sx={{ cursor: 'pointer' }} onClick={() => window.open(`${getPictureUrl(url)}`)} > 
                  <FileIcon size={24} type={getFileExtension(url)} color={theme.palette.error.main} />
                  <Typography variant='body2' fontWeight={700} color={'color.primaryMain'} noWrap>{url}</Typography>
                  {/* <Typography 
                    variant={'body1'} 
                    display={'flex'} 
                    alignItems={'center'} 
                    sx={{ wordBreak: 'break-word' }}
                    component={'img'}
                    src={getPictureUrl(url)}
                  /> */}
                </Box>
              ))
            }
            {/*  */}
          </Stack>
        </CardContent>

        {
          [COMMENT_FLAG.Replied].includes(Number(details?.messageStatus)) && (
            <CardContent sx={{ borderTop: `1px solid ${theme.palette.divider}` }}>
              <Stack spacing={2}>

                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                  <Stack direction={'row'} spacing={1} alignItems={'center'}>
                    <Avatar sx={{ width: 32, height: 32 }} src={(getAssetsUrl('images/avatars/avatar_1.jpg'))} />
                    <Typography variant='body2' fontWeight={700}>客服(16996) 回覆</Typography>
                  </Stack>
                  <Typography variant='body2'>{details?.processTime}</Typography>
                </Stack>

                <Typography variant='body1' sx={{ wordBreak: 'break-word' }}>
                  {details?.processContent}
                </Typography>

                <Stack direction={'row'} justifyContent={'flex-end'} spacing={1}>
                  <ButtonBase
                    sx={{
                      fontWeight: 700,
                      padding: theme.spacing(0.5, 1),
                      color: 'color.primaryMain',
                      transition: 'all .4s ease',
                      '&:hover': {
                        backgroundColor: 'color.primaryBlue310',
                      }
                    }}
                    onClick={async () => {
                      await dispatch(onFeedbackHelp({ haveOrNo: HLEP_FLAG.True, id: details?.id }));
                      await dispatch(queryFeedbackDetails(details));
                    }}
                  >
                    有幫助
                    <SvgLikeFill variant={[HLEP_FLAG.True].includes(details?.haveHelp) ? 'contained' : 'outlined'} />
                  </ButtonBase>
                  <ButtonBase
                    sx={{
                      fontWeight: 700,
                      padding: theme.spacing(0.5, 1),
                      color: 'color.primaryMain',
                      transition: 'all .4s ease',
                      '&:hover': {
                        backgroundColor: 'color.primaryBlue310',
                      }
                    }}
                    onClick={async () => {
                      await dispatch(onFeedbackHelp({ haveOrNo: HLEP_FLAG.Fasle, id: details?.id }));
                      await dispatch(queryFeedbackDetails(details));
                    }}
                  >
                    沒有幫助
                    <SvgDislikeFill variant={[HLEP_FLAG.Fasle].includes(details?.haveHelp) ? 'contained' : 'outlined'} />
                  </ButtonBase>
                </Stack>

              </Stack>
            </CardContent>
          )
        }
      </Card>
    </Drawer>
  );
};

export default memo(FeedbackDetails);
